import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getIcon } from '../services/iconService';


interface HomePageButtonProps {
  title: string;
  isShown: boolean;
  route: string;
  icon: string;
  navigate: (to: string) => void;
}


class HomePageButton extends React.Component<HomePageButtonProps> {
  handleClick = () => {
    const { route, navigate } = this.props;
    if (route) {
      navigate(route);
    }
  };


  render() {
    const { title, isShown, icon } = this.props;

    if (!isShown) return null;

    return (
      <div
        className="homePageCard"
        onClick={this.handleClick}
      >
        <img style={{ maxWidth: '100px', maxHeight: '100px' }} src={getIcon(icon)} alt={icon}></img>
        <h3 style={{ textAlign: 'center', marginTop: '5px', maxWidth: '95%' }}>{title}</h3>
        {/* <button
          type="button"
          style={{
            width: '100%',
            backgroundColor: '#51BCE4',
            color: 'white',
            padding: '0.5rem 1rem',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '1rem',
          }}
          onClick={this.handleClick}
        >
          {title}
        </button> */}
      </div>
    );
  }
}

// Functional wrapper to pass navigate function from react-router-dom hook
export default function HomePageButtonsWrapper(props: Omit<HomePageButtonProps, 'navigate'>) {
  const navigate = useNavigate();

  // Cast navigate to a simple function accepting string to satisfy typing
  return <HomePageButton {...props} navigate={(to) => navigate(to)} />;
}
